import {Select, Text} from '@mantine/core';
import type {FC, ForwardRefExoticComponent, RefAttributes} from 'react';
import type {ReportType} from '../../../../../../core/entities/reportAnalytics/schema';
import {ModalCancelButton} from '../ModalCancelButton';
import {ModalSubmitButton} from '../ModalSubmitButton';
import {SelectedInfoBox} from './SelectedInfoBox';

type DepartmentOption = {
  value: string;
  label: string;
  reportType?: ReportType;
};

type Props = {
  onBack: () => void;
  onSubmit: () => void;
  companyName: string;
  departmentOptions: DepartmentOption[];
  selectedOption: string;
  onSelectChange: (value: string | null) => void;
  itemComponent?: ForwardRefExoticComponent<
    DepartmentOption &
      React.ComponentPropsWithoutRef<'div'> &
      RefAttributes<HTMLDivElement>
  >;
  badgeComponent?: React.ReactNode;
};

export const AiTodoDepartmentSelectContent: FC<Props> = ({
  onBack,
  onSubmit,
  companyName,
  departmentOptions,
  selectedOption,
  onSelectChange,
  itemComponent,
  badgeComponent,
}) => {
  return (
    <div className="flex flex-col gap-24">
      <SelectedInfoBox companyName={companyName} />
      <div className="flex flex-col gap-8">
        <Text className="text-sm text-black-2">
          部門・職種を選択してください
        </Text>
        <Select
          placeholder="選択してください"
          data={departmentOptions}
          value={selectedOption}
          onChange={onSelectChange}
          maxDropdownHeight={300}
          itemComponent={itemComponent}
          icon={badgeComponent}
          iconWidth={80}
          withinPortal
          styles={{
            input: {
              borderRadius: '12px',
            },
          }}
        />
      </div>
      <div className="flex items-center justify-center gap-16">
        <ModalCancelButton onClick={onBack}>戻る</ModalCancelButton>
        <ModalSubmitButton onClick={onSubmit} disabled={!selectedOption}>
          次へ
        </ModalSubmitButton>
      </div>
    </div>
  );
};
